/*tslint:disable*/


import { Component, forwardRef, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AreaService } from '../services/area.service';
import { UISelectBoxModule } from '../select-box/select-box.component';


const /** @type {?} */ noop = () => {
};

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AreaSelectComponent),
    multi: true
};
export class AreaSelectComponent implements ControlValueAccessor {

     label: any; // 显示值的标签
     level: any; // 控制选择区域的级别
     width: any;
     height: any;
     border;
     valueType = '';

     onChange = new EventEmitter();
/**
 * @param {?} areaService
 */
constructor(public areaService: AreaService) {
    }
public onTouchedCallback: () => void = noop;
public onChangeCallback: (_: any) => void = noop;
public innerValue;
/**
 * @return {?}
 */
get value(): any {
        return this.innerValue;
    };
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * @param {?} $event
 * @return {?}
 */
onChangeHandler($event) {
        console.log($event)
        this.onChange.emit($event);
    }

    dataHandler: Function = this.areaService.selectBoxHandler();

    labelHandler: Function = this.areaService.selectBoxLabelHandler();
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "yzt-area",
    template: `
    <div class="area-select">
        <ui-select-box [(ngModel)]="value"
                [valueType]="valueType"
                [label]="label"
                [label-handler]="labelHandler"
                [data-handler]="dataHandler"
                (onChange)="onChangeHandler($event)"
                [width]="width" [height]="height" [border]="border" [level]="level"></ui-select-box>
    </div>`,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AreaService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
'level': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'border': [{ type: Input },],
'valueType': [{ type: Input },],
'onChange': [{ type: Output },],
};
}

function AreaSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
AreaSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AreaSelectComponent.ctorParameters;
/** @type {?} */
AreaSelectComponent.propDecorators;
/** @type {?} */
AreaSelectComponent.prototype.label;
/** @type {?} */
AreaSelectComponent.prototype.level;
/** @type {?} */
AreaSelectComponent.prototype.width;
/** @type {?} */
AreaSelectComponent.prototype.height;
/** @type {?} */
AreaSelectComponent.prototype.border;
/** @type {?} */
AreaSelectComponent.prototype.valueType;
/** @type {?} */
AreaSelectComponent.prototype.onChange;
/** @type {?} */
AreaSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
AreaSelectComponent.prototype.onChangeCallback;
/** @type {?} */
AreaSelectComponent.prototype.innerValue;
/** @type {?} */
AreaSelectComponent.prototype.dataHandler;
/** @type {?} */
AreaSelectComponent.prototype.labelHandler;
/** @type {?} */
AreaSelectComponent.prototype.areaService;
}

export class AreaSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        AreaSelectComponent
    ],
    exports: [AreaSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        UISelectBoxModule
    ],
    providers:[
        AreaService
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AreaSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
AreaSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AreaSelectModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
